// JOBE-0167.5: ForgetLogRow — single row in the Forget log feed.

import { useState } from 'react';
import { StatusPill } from '../../components/StatusPill/StatusPill.jsx';

const LIFECYCLE_TONE = {
  tombstoned: 'tombstoned',
  hard_deleted: 'tombstoned', // share the same tone; hard-delete is a write event, not a render lifecycle
};

/**
 * @param {object} props
 * @param {object} props.event  — { ts, operator, reason_class, reason, urn, body_snippet, lifecycle, cascade }
 */
export function ForgetLogRow({ event }) {
  const tone = LIFECYCLE_TONE[event.lifecycle] || 'tombstoned';
  const lifecycleLabel = event.lifecycle || 'tombstoned';
  const c = event.cascade || {};
  return (
    <li className="forget-log-row" data-testid="forget-log-row">
      <div className="forget-log-row__header">
        <span className="forget-log-row__ts" data-testid="forget-log-row-ts">{event.ts}</span>
        <span> · operator: {event.operator || ''}</span>
        <span> · reason: {event.reason_class || ''}{event.reason ? ` / ${event.reason}` : ''}</span>
      </div>
      <div className="forget-log-row__urn-row">
        <CopyableUrn urn={event.urn} />
        <StatusPill tone={tone} label={lifecycleLabel} />
      </div>
      {event.body_snippet && (
        <div className="forget-log-row__snippet">"{event.body_snippet}"</div>
      )}
      <div className="forget-log-row__cascade" data-testid="forget-log-row-cascade">
        Cascade:{' '}
        {(c.summary_count ?? 0)} summary ·{' '}
        {(c.derived_from_count ?? 0)} derivedFrom ·{' '}
        {(c.retrieval_cache_count ?? 0)} retrieval-cache
      </div>
    </li>
  );
}

function CopyableUrn({ urn }) {
  const [copied, setCopied] = useState(false);
  function handle(e) {
    e.stopPropagation();
    if (!urn) return;
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(urn).catch(() => {});
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }
  return (
    <span
      className={`forget-log-urn${copied ? ' forget-log-urn--copied' : ''}`}
      role="button"
      tabIndex={0}
      data-testid="forget-log-urn"
      data-urn={urn || ''}
      onClick={handle}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handle(e); } }}
    >
      <span>{urn || ''}</span>
      <span aria-hidden="true" className="forget-log-urn__glyph">{copied ? '✓' : '⎘'}</span>
    </span>
  );
}

export default ForgetLogRow;
